import React, { useState } from 'react';
import LaboratoryList from '../LaboratoryList/LaboratoryList';
import LaboratoryRequestList from '../LaboratoryRequestsList/LaboratoryRequestsList';
import LaboratoryRequestCreateForm from './LaboratoryRequestCreateForm';
import LaboratoryRequestCreateWizard from '../LaboratoryRequestCreateWizard/LaboratoryRequestCreateWizard';

interface Props {
	patientId: string;
	onRequestCreate: () => void;
	onRequestSelect?: () => void;
}

enum LaboratoryRequestCreateStatus {
	LABORATORY_SELECTION = 'laboratory_selection',
	REQUEST_SELECTION = 'request_selection',
	FORM_FILL = 'form_fill',
}

const LaboratoryRequestCreate: React.FC<Props> = ({
	patientId,
	onRequestCreate,
	onRequestSelect,
}) => {
	const [state, setState] = useState<LaboratoryRequestCreateStatus>(
		LaboratoryRequestCreateStatus.LABORATORY_SELECTION,
	);
	const [selectedLaboratoryId, setSelectedLaboratoryId] = useState<
		string | undefined
	>(undefined);
	const [selectedFormId, setSelectedFormId] = useState<string | undefined>(
		undefined,
	);

	const selectLaboratory = (laboratoryId: string) => {
		setSelectedLaboratoryId(laboratoryId);
		setState(LaboratoryRequestCreateStatus.REQUEST_SELECTION);
	};

	const selectRequest = (wizardId: string) => {
		setSelectedFormId(wizardId);
		setState(LaboratoryRequestCreateStatus.FORM_FILL);
		onRequestSelect?.();
	};

	switch (state) {
		case LaboratoryRequestCreateStatus.LABORATORY_SELECTION:
			return <LaboratoryList onClick={selectLaboratory} />;
		case LaboratoryRequestCreateStatus.REQUEST_SELECTION:
			if (selectedLaboratoryId) {
				return (
					<LaboratoryRequestList
						laboratoryId={selectedLaboratoryId}
						onClick={selectRequest}
					/>
				);
			}
			break;
		case LaboratoryRequestCreateStatus.FORM_FILL:
			if (selectedFormId) {
				return (
					<LaboratoryRequestCreateWizard
						onCreate={onRequestCreate}
						formId={selectedFormId}
						patientId={patientId}
					/>
				);
			}
			break;
	}

	return <></>;
};

export default LaboratoryRequestCreate;
